// UpdatesSection.jsx
import React, { useState, useEffect } from "react";
import "./UpdatesSection.css";

import img1 from "../../assets/navratri.jpg";
import img2 from "../../assets/carpetcleaning.jpg";
import img3 from "../../assets/steamironing.jpg";

const slides = [
    {
      img: img1,
      title: "Happy Navratri",
      desc1:
        "Our NeatnClean team wishes you a joyful Navratri filled with prosperity and good health.",
      desc2:
        "May these nine nights bring color and positivity to your home — count on us for fresh, spotless care all festival long."
    },
    {
      img: img2,
      title: "Carpet Cleaning Services",
      desc1:
        "Deep cleaning for carpets, rugs and upholstery with professional equipment.",
      desc2:
        "Remove stains, dust and allergens — giving your home a healthier environment."
    },
    {
      img: img3,
      title: "Steam Ironing Services",
      desc1:
        "Get perfectly pressed clothes with our premium steam ironing service.",
      desc2:
        "Convenience and care combined, delivered right to your doorstep."
    }
  ];

const images = [img1, img2, img3];
const UpdatesSection = () => {
    const [index, setIndex] = useState(0);
  
    useEffect(() => {
      const timer = setInterval(() => {
        setIndex((prev) => (prev + 1) % slides.length);
      }, 3000);
      return () => clearInterval(timer);
    }, []);
  
    return (
    <section className="showcase-section">
      <div className="showcase-card">
        <div className="showcase-image-container">
          <img
            src={slides[index].img}
            alt={`slide ${index}`}
            className="showcase-image"
          />
          <div className="dots" aria-hidden="true">
            {slides.map((_, i) => (
              <span
                key={i}
                className={`dot ${index === i ? "active" : ""}`}
                onClick={() => setIndex(i)}
              />
            ))}
          </div>
        </div>

        <div className="showcase-text">
          <h2>{slides[index].title}</h2>
          <p>{slides[index].desc1}</p>
          <p>{slides[index].desc2}</p>
        </div>
      </div>
    </section>
    );
  };
  
  export default UpdatesSection;
  